export default __webpack_public_path__ + "static/media/exterior.d51b4481.jpg";